export const RoutesList = {
  Dashboard: '/dashboard',
  AddUser: '/add-user',
  ViewReport: '/report/:id',
  PrintReport: '/print/report/:id',
}
